export class ViewModelEnviarNotificacaoPessoa {
    titulo: string;
    mensagem: string;
    idPessoa: number;
}